import { containerConnect } from "@configuratorware/configurator-frontendgui/Framework/ComponentContainer";
import BasketList from "../../Components/BasketList/BasketList";
import { fetchBasket } from "../../Reducers/Basket/Actions";

const mapStateToProps = (state) => {
  return {
    Component: BasketList,
    isLoggedIn: state.login.isLoggedIn,
    basketItems: state.basket.items
  };
};

const mapDispatchToProps = (dispatch) => ({
  loadBasket: () => dispatch(fetchBasket())
});

export default containerConnect(mapStateToProps, mapDispatchToProps);